module.exports = __webpack_public_path__ + "static/img/hync_banner.6c0ebf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hync_banner.png
// module id = mDHG
// module chunks = 1